"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoursOfOperationModel = void 0;
const HoursOfOperationTimeModel = {
    type: Object,
    schema: {
        open: { type: String },
        close: { type: String },
        isOpen: { type: Boolean },
    },
    default: null,
};
const HoursOfOperationModel = {
    type: Object,
    schema: {
        1: HoursOfOperationTimeModel,
        2: HoursOfOperationTimeModel,
        3: HoursOfOperationTimeModel,
        4: HoursOfOperationTimeModel,
        5: HoursOfOperationTimeModel,
        6: HoursOfOperationTimeModel,
        7: HoursOfOperationTimeModel,
    },
};
exports.HoursOfOperationModel = HoursOfOperationModel;
